import { connect } from 'react-redux';
import { PrivacyPolicy } from '../../components';

export default connect(null)(PrivacyPolicy);